import { ApiError } from '../instance/error';
import { resolveErrorAction } from './resolve-error-action';

export function shouldThrowOnError(error: Error): boolean {
  if (error instanceof ApiError) {
    return !resolveErrorAction(error).handled;
  }

  return true;
}
